import PropTypes from "prop-types";
import defaultStyle from "./styles";

const PremierButton = ({
  disabled = false,
  buttonText,
  onClick,
  style = defaultStyle,
  className,
}) => (
  <div className={className || style.PremierButtonContainer}>
    <button
      className={style.PremierButton}
      onClick={onClick}
      aria-label={buttonText}
      disabled={disabled}
    >
      {buttonText}
    </button>
  </div>
);
PremierButton.propTypes = {
  disabled: PropTypes.bool,
  buttonText: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default PremierButton;
